import { Component, ElementRef, HostListener, OnInit, inject, input, output } from '@angular/core';

@Component({
  selector: 'di-grid-header-top',
  templateUrl: './grid-header-top.component.html',
  standalone: false,
  host: {
    class: 'tw:block',
  },
})
export class GridHeaderTopComponent implements OnInit {
  autosizeColumns = output();
  getExcel = output();
  getCsv = output();
  clearFilters = output();
  resetColumns = output();
  toggleFloatingFilter = output<boolean>();

  isFloatingFilterPresent = input<boolean>(false);
  isFilterEnabled = input<boolean>(true);

  isDropdownOpen = false;
  isFloatingFilterVisible = true;

  private readonly elementRef = inject(ElementRef);

  ngOnInit() {
    this.isFloatingFilterVisible = this.isFloatingFilterPresent();
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target: EventTarget | null): void {
    const settingsBtnEl = this.elementRef.nativeElement.querySelector('#settings-btn');
    if (!settingsBtnEl?.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

  onFilterButtonClick() {
    this.isFloatingFilterVisible = !this.isFloatingFilterVisible;
    this.toggleFloatingFilter.emit(this.isFloatingFilterVisible);

    const grid = this.elementRef.nativeElement.parentElement?.querySelector('.ag-theme-visma');
    if (!grid) {
      return;
    }

    if (this.isFloatingFilterVisible) {
      grid.classList.remove('visma-floating-filter-row-hidden');
    } else {
      grid.classList.add('visma-floating-filter-row-hidden');
    }
  }
}
